import React from 'react';
import { Upload, Button, Flex, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import apis from '../../services/Apis';
import useAttachment from '../../hooks/useAttachment';

const MAX_FILE_SIZE_MB = 2; // set to whatever your actual server limit is

const FileUpload = ({ fileList, row, action, status, isMandatory }) => {
  const { upload, remove, loading } = useAttachment({
    url: `${apis.UPLOAD}`
  });

  const isDisabled = status === 1 || status === 2 || status === 3;

  return (
    <Upload
      beforeUpload={(file) => {
        const isUnderLimit = file.size / 1024 / 1024 < MAX_FILE_SIZE_MB;
        if (!isUnderLimit) {
          message.error(`File must be smaller than ${MAX_FILE_SIZE_MB}MB.`);
          return Upload.LIST_IGNORE; // rejects the file, never enters fileList or customRequest
        }
        return true;
      }}
      customRequest={async (e) => {
        if (status === 3) return;

        const newFile = await upload({ ...e });
        if (!newFile) return; // upload failed — don't touch attachment list, don't crash

        const currentFiles = row.attachment || [];
        action({ ...row, attachment: [...currentFiles, newFile] });
      }}
      onRemove={async (e) => {
        if (status === 3) return;

        const removedFileId = await remove({ ...e });
        if (!removedFileId) return;

        const currentFiles = row.attachment || [];
        const filesAfterRemove = currentFiles.filter((file) => file.id !== removedFileId);
        action({ ...row, attachment: [...filesAfterRemove] });
      }}
      fileList={fileList?.length > 0 ? [...fileList] : []}
      itemRender={(originNode) => (
        <span
          style={{
            pointerEvents: status === 3 ? 'none' : 'auto',
            color: status === 3 ? '#ccc' : 'inherit'
          }}
        >
          {originNode}
        </span>
      )}
      disabled={isDisabled}
    >
      <Flex>
        <Button disabled={isDisabled} loading={loading} icon={<UploadOutlined />}>
          Click to Upload
        </Button>
        {isMandatory && (
          <span style={{ color: 'red', marginLeft: '4px', fontSize: 20, marginTop: -10 }}>*</span>
        )}
      </Flex>
    </Upload>
  );
};

export default FileUpload;